"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _lodash = _interopRequireDefault(require("lodash"));
// Packages

// Hook
function useScroll() {
  const {
    0: scrollValues,
    1: setScrollValues
  } = (0, _react.useState)({
    scrollingDirection: "",
    domScrollTop: undefined
  });
  (0, _react.useEffect)(() => {
    function handleScroll() {
      const domScrollTop = document.documentElement.scrollTop;
      setScrollValues(prev => ({
        scrollingDirection: prev.domScrollTop < domScrollTop ? "down" : "up",
        domScrollTop,
        prevDomScrollTop: prev.domScrollTop,
        prevScrollingDirection: prev.scrollingDirection
      }));
    }
    handleScroll();
    const throttledHandleScroll = _lodash.default.throttle(handleScroll, 100);
    window.addEventListener("scroll", throttledHandleScroll);
    return () => window.removeEventListener("scroll", throttledHandleScroll);
  }, []);
  return scrollValues;
}
var _default = useScroll;
exports.default = _default;